import { INIT } from './view'

export const NAMESPACE = 'KanBo/Card/subCards/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'

const defaultCardState = {}

const initialState = {}

const subCardDefaults = {
  id: null,
  cardId: null
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: {
          ...defaultCardState,
        }
      }
    case ADD:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          [action.payload.subCard.id]: {
            ...subCardDefaults,
            ...state[action.payload.cardId][action.payload.subCard.id],
            ...action.payload.subCard,
          }
        }
      } : undefined
    case ADD_ARRAY: {
      if (!state[action.payload.cardId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId]
        }
      }

      action.payload.array.forEach(subCard => {
        newState[action.payload.cardId][subCard.id] = {
          ...subCard
        }
      })

      return newState
    }
    case REMOVE: {
      if (!state[action.payload.cardId] || !state[action.payload.cardId][action.payload.subCardId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId]
        }
      }

      delete newState[action.payload.cardId][action.payload.subCardId]

      return newState
    }
    default: return state
  }
}

export function add ({ cardId, subCard }) {
  return {
    type: ADD,
    payload: {
      cardId,
      subCard
    }
  }
}

export function addArray ({ cardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      cardId,
      array
    }
  }
}

export function remove ({ cardId, subCardId }) {
  return {
    type: REMOVE,
    payload: {
      cardId,
      subCardId
    }
  }
}
